export const alignments = (type: number | null) => [
  { id: 1, name: 'ТТН', icon: 'exportpdf' },
  { id: 4, name: 'ТТН 2', icon: 'exportpdf' },
  { id: 7, name: 'Паспорт качества', icon: 'exportpdf' },
  { id: 5, name: 'Накладная', icon: 'exportpdf' },
  { id: 2, name: 'Редактировать', icon: 'edit' },
  { id: 9, name: 'Аварийная догрузка', icon: 'addtableheader' },
  { id: 6, name: 'Перенос в другую заявку', icon: 'revert' },
  { id: 8, name: type === 3 ? 'Отменить частичный перенос' : 'Частичный перенос в другую заявку', icon: 'revert' },
  { id: 3, name: 'Удалить', icon: 'trash' },
];
